import {Keyword} from "../domain/entities/keyword.entity";
import {AbstractCommand} from "./abstract.command";
import {CarriesEntity} from "./carries-entity.interface";
import {CommandName} from "./command-name.enum";
import {RecolorContent} from "./payloads/recolor-content";

/**
 * Recolors an existing keyword (label): colour and text colour (feature plan 0074).
 *
 * ADR-016 action command: the payload is a `RecolorContent`, serialized by the generic path — no transformer.
 * The keyword itself travels as `entity` (`CarriesEntity`) for the local `entity.changed`.
 */
export class RecolorKeywordCommand extends AbstractCommand<RecolorContent> implements CarriesEntity<Keyword> {

    public name = CommandName.RECOLOR_KEYWORD;

    public tags: string[] = [`entity`, `update`, `keyword`];

    /** @param changed the changed fields; only `color` and `textColor` among them are sent */
    constructor(public readonly entity: Keyword, changed: ReadonlyArray<string>) {
        super('keyword', entity.uid, RecolorContent.of(entity, changed));
    }
}
